<template>
  <div class="carriage-layout__wrapper">
    <div
      class="carriage-layout__content"
      :style="contentStyle"
    >
      <img
        :src="carriageImageSrc"
        alt="Carriage Layout"
        class="carriage-image"
        ref="carriageImage"
        @load="onImageLoad"
      />
      <div class="seats-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref, computed, PropType } from 'vue'

  export default defineComponent({
    name: 'CarriageImage',
    props: {
      carriageImageSrc: {
        type: String,
        required: true,
      },
      floorplanDimensions: {
        type: Object as PropType<{ width: number; height: number }>,
        required: true,
      },
    },
    emits: ['imageLoaded', 'dimensionsChanged'],
    setup(props, { emit }) {
      const carriageImage = ref<HTMLImageElement | null>(null)

      const onImageLoad = () => {
        try {
          if (carriageImage.value) {
            emit('dimensionsChanged', {
              width: carriageImage.value.clientWidth || 0,
              height: carriageImage.value.clientHeight || 0,
            })
          }
          emit('imageLoaded')
        } catch (error) {
          console.error('Error in carriage image load:', error)
          // Still emit the event to prevent blocking the UI flow
          emit('imageLoaded')
        }
      }

      const contentStyle = computed(() => {
        // Add defensive checks for floorplanDimensions
        if (!props.floorplanDimensions || typeof props.floorplanDimensions !== 'object') {
          console.warn('[CarriageImage] Missing or invalid floorplanDimensions:', props.floorplanDimensions)
          return {
            width: '100%',
            height: 'auto',
            transform: 'scale(1)',
            transformOrigin: 'top left',
          }
        }
        
        // Additional safety checks for width and height properties
        const width = (props.floorplanDimensions?.width && typeof props.floorplanDimensions.width === 'number') 
          ? props.floorplanDimensions.width 
          : 0
        const height = (props.floorplanDimensions?.height && typeof props.floorplanDimensions.height === 'number') 
          ? props.floorplanDimensions.height 
          : 0
        
        if (width === 0 || height === 0) {
          console.warn('[CarriageImage] Invalid dimensions:', { width, height, floorplanDimensions: props.floorplanDimensions })
          return {
            width: '100%',
            height: 'auto',
            transform: 'scale(1)',
            transformOrigin: 'top left',
          }
        }
        
        return {
          width: `${width}px`,
          height: `${height}px`,
          transform: 'scale(1)',
          transformOrigin: 'top left',
        }
      })

      return {
        onImageLoad,
        carriageImage,
        contentStyle,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .carriage-layout__wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .carriage-layout__content {
    position: relative;
    display: block;
    display: flex;
  }

  .carriage-image {
    display: block;
    /* width: 100%;
    height: auto; */
    /* width: 687px; */
  }

  .seats-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;

    :deep(*) {
      pointer-events: auto;
    }
  }
</style>
